import { render, staticRenderFns } from "./UnionView.vue?vue&type=template&id=78507be0&scoped=true"
import script from "./UnionView.vue?vue&type=script&lang=js"
export * from "./UnionView.vue?vue&type=script&lang=js"
import style0 from "./UnionView.vue?vue&type=style&index=0&id=78507be0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78507be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78507be0')) {
      api.createRecord('78507be0', component.options)
    } else {
      api.reload('78507be0', component.options)
    }
    module.hot.accept("./UnionView.vue?vue&type=template&id=78507be0&scoped=true", function () {
      api.rerender('78507be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/UnionView.vue"
export default component.exports